import { apiFetch } from "../../utils/apiFetch";

/** Spiegel von apps/api/src/ticket/ticket-vorschlag.entity.ts (TICKET_VORSCHLAG_STATUS). */
export type VorschlagStatus = "wartet" | "gesendet" | "fertig" | "fehler";

/**
 * Spiegel von TicketVorschlagLauf (apps/api/src/ticket/ticket-vorschlag.entity.ts) — das echte
 * `lauf.json` des ticket-agent: `modelle[]`, `tokens` als rohes `usage`-Objekt von Claude.
 * Alle Felder optional, unbekannte bleiben erhalten.
 */
export type VorschlagLauf = {
  dauerMs?: number;
  exitCode?: number | null;
  modelle?: string[];
  kostenUsd?: number | null;
  tokens?: Record<string, unknown> | null;
  runden?: number | null;
  zeitlimit?: boolean;
  [weitere: string]: unknown;
};

/** Spiegel von `VorschlagKurz` (apps/api/src/ticket/ticket-vorschlag.service.ts) — Listenzeile ohne die großen Texte. */
export type VorschlagKurz = {
  id: number;
  ticketId: number;
  stand: number;
  status: VorschlagStatus;
  auftragId: string | null;
  versuche: number;
  fehler: string | null;
  angelegt: string;
  gesendet: string | null;
  fertig: string | null;
};

/** Eine Version vollständig (Detail-Anzeige, Download). */
export type Vorschlag = VorschlagKurz & {
  analyse: string | null;
  plan: string | null;
  lauf: VorschlagLauf | null;
  neu: boolean;
};

export type VorschlagListe = { aktiv: boolean; versionen: VorschlagKurz[]; neueste: Vorschlag | null };

/**
 * Tickets Teil 2 — Zugriff auf die Claude-Lösungsvorschläge (`GET/POST
 * /api/tickets/:id/vorschlaege*`, siehe `apps/api/src/ticket/ticket.controller.ts`).
 * Nur admin/gfgl sehen diese Routen — die Rechteprüfung sitzt im Backend, hier
 * wird nur der Zugriff geformt.
 */
export const vorschlagService = {
  async liste(ticketId: number): Promise<VorschlagListe> {
    return (await apiFetch<VorschlagListe>(`tickets/${ticketId}/vorschlaege`)).data;
  },
  async version(ticketId: number, stand: number): Promise<Vorschlag> {
    return (await apiFetch<Vorschlag>(`tickets/${ticketId}/vorschlaege/${stand}`)).data;
  },
  /** „Neu erstellen“ bzw. „Erneut versuchen“ — 409, wenn die Funktion aus ist. */
  async neu(ticketId: number): Promise<Vorschlag> {
    return (await apiFetch<Vorschlag>(`tickets/${ticketId}/vorschlaege/neu`, { method: "POST" })).data;
  },
  /** API-relativer Pfad für den Download per `fetch(apiUrl(...))` → Blob. */
  dateiPfad: (ticketId: number, stand: number, datei: "analyse.md" | "plan.md") =>
    `tickets/${ticketId}/vorschlaege/${stand}/${datei}`,
};
